import { isEmpty } from 'lodash'
import { legendDefault } from '.'
import { defaultExportMenu, getLineSeries } from '../helpers'

export default ({ config = {}, data = {}, color = {}, legendLabels = {} }) => {
  const { labelColor } = color
  const { series, ...restConfig } = config
  const {
    title,
    xKey,
    scrollbar,
    axisRanges,
    disabledAnimations = false,
    exportingMenu
  } = restConfig
  const keys = []

  if (!isEmpty(series)) {
    series.forEach((el) => {
      // get custom legend labels with translated values
      !isEmpty(legendLabels) &&
        Object.keys(legendLabels).forEach((key) => {
          if (el.includes(key)) {
            keys.push(legendLabels[key])
          }
        })
    })
  }

  const chartConfig = {
    data: data,
    type: 'XYChart',
    series: getLineSeries({
      series,
      otherConfig: {
        legendLabel: keys,
        color,
        disabledAnimations,
        ...restConfig
      }
    }),
    cursor: {},
    xAxes: [
      {
        type: 'CategoryAxis',
        dataFields: {
          category: xKey
        },
        rangeChangeDuration: 500,
        renderer: {
          labels: {
            fontSize: 10,
            fill: labelColor
          },
          grid: {
            template: {
              strokeWidth: 0,
              fill: labelColor
            }
          },
          line: {
            strokeOpacity: 0.3,
            fill: labelColor
          },
          minGridDistance: 60,
          cellStartLocation: 0.1,
          cellEndLocation: 0.9,
          maxLabelPosition: 0.98
        }
      }
    ],
    yAxes: [
      {
        title: {
          text: title || null,
          fill: labelColor,
          fontSize: 12
        },
        axisRanges: !isEmpty(axisRanges) && [
          {
            value: axisRanges?.value, // this
            grid: {
              stroke: labelColor,
              strokeWidth: 2,
              strokeOpacity: 1
            },
            label: {
              text: axisRanges?.text, // this
              inside: true,
              fill: labelColor,
              verticalCenter: 'bottom',
              paddingBottom: 3
            }
          }
        ],
        id: 'CommonYAxis',
        type: 'ValueAxis',
        renderer: {
          line: {
            strokeOpacity: 0.3,
            fill: labelColor
          },
          labels: {
            fill: labelColor,
            fontSize: 10
          }
        }
      },
      {
        type: 'ValueAxis',
        renderer: {
          opposite: true,
          line: {
            strokeOpacity: 0
          },
          labels: {
            fill: labelColor,
            fontSize: 10
          }
        }
      }
    ],
    scrollbarX: {
      disabled: !scrollbar,
      animationDuration: 500,
      parent: 'bottomAxesContainer'
    },
    legend: legendDefault(labelColor)
  }

  // Export menu
  if (exportingMenu && exportingMenu.enabled) {
    if (isEmpty(exportingMenu.config)) {
      chartConfig.exporting = defaultExportMenu
    } else {
      chartConfig.exporting = exportingMenu.config
    }
  }

  return chartConfig
}
